import * as React from 'react';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import StarIcon from '@mui/icons-material/StarBorder';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

const tiers = [
  {
    title: 'Free Access to sample reports',
    price: '0',
    description: ['Limited Texas City Tax Trends', 'Limited Texas School Enrollment Trends'],
    buttonText: 'Sign up for free',
    buttonVariant: 'outlined',
    link:'/signup',
  },
  {
    title: 'All Reports(Texas Schools and Cities)',
    subheader: 'Most popular',
    price: '15',
    description: ['All School Charts and Reports', 'All City Charts and Reports', 'Report Exports(PDF and CSV)', 'Custom Reports($20 each)'],
    buttonText: 'Sign up for All Reports',
    buttonVariant: 'contained',
    link:'/signup',
  },
  {
    title: 'All School Reports(Texas Schools)',
    price: '10',
    description: ['All School Charts and Reports','Report Exports(PDF and CSV)', 'Custom Reports($25 each)'],
    buttonText: 'Sign up (TX Schools)',
    buttonVariant: 'outlined',
    link:'/signup',
  },
  {
    title: 'All City Reports(Texas Cities)',
    price: '10',
    description: ['All City Charts and Reports','Report Exports(PDF and CSV)', 'Custom Reports($25 each)'],
    buttonText: 'Sign up (TX Cities)',
    buttonVariant: 'outlined',
    link:'/signup',
  },
];

export default function Pricing() {
  return (
    <>
      {/* Hero unit */}
      <Container disableGutters maxWidth='sm' component='main' sx={{ pt: 8, pb: 6 }}>
        <Typography component='h1' variant='h2' align='center' color='text.primary' gutterBottom>
          Pricing
        </Typography>
        <Typography variant='h5' align='center' color='text.secondary' component='p'>
          Different access levels are available for you research needs.  
        </Typography>
      </Container>
      {/* End hero unit */}
      <Container maxWidth='md' component='main'>
        <Grid container spacing={5} alignItems='flex-end'>
          {tiers.map((tier) => (
            // Enterprise card is full width at sm breakpoint
            <Grid item key={tier.title} xs={12} sm={tier.title === 'Enterprise' ? 12 : 6} md={4}>
              <Card>
                <CardHeader
                  title={tier.title}
                  subheader={tier.subheader}
                  titleTypographyProps={{ align: 'center' }}
                  action={tier.title === 'Pro' ? <StarIcon /> : null}
                  subheaderTypographyProps={{
                    align: 'center',
                  }}
                  sx={{
                    backgroundColor: (theme) => (theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[700]),
                  }}
                />
                <CardContent>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'baseline',
                      mb: 2,
                    }}
                  >
                    <Typography component='h2' variant='h3' color='text.primary'>
                      ${tier.price}
                    </Typography>
                    <Typography variant='h6' color='text.secondary'>
                      /mo
                    </Typography>
                  </Box>
                  <ul>
                    {tier.description.map((line) => (
                      <Typography component='li' variant='subtitle1' align='center' key={line}>
                        {line}
                      </Typography>
                    ))}
                  </ul>
                </CardContent>
                <CardActions>
                  <Button fullWidth variant={tier.buttonVariant} href={tier.link}>
                    {tier.buttonText}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
     
    </>
  );
}
